import format from 'date-fns/format';
import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Grid, Header, Segment, Table } from 'semantic-ui-react';
import ReadAxiosc from '../axiosComponent/commonRead';
import AgGridTable from '../common/agGridTable'
function OrderPlacement() {

    const [start, setStart] = useState('')
    const [end, setEnd] = useState('')
    const [isLoading, setisLoading] = useState(false)
    const [data, setdata] = useState(null)
    const [monthWise, setMonthWise] = useState([])
    const [defaultStartDate, setdefaultStartDate] = useState(new Date())
    const [defaultEndDate, setdefaultEndDate] = useState(new Date())
    const endDateHandle = (e) => {
        setEnd(e)
    }
    const handleSubmit = () => {
        //  https://dev-commongateway.elixia.tech/dispatch/orderPlacementRatio?fromDate=2021-03-01&toDate=2021-04-12&customerNumber=1158
        let startDate = start ? format(start, 'yyyy-MM-dd') : format(defaultStartDate.setDate(1), 'yyyy-MM-dd')
        let endDate = end ? format(end, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')
        ReadAxiosc({
            completeURL: `${process.env.REACT_APP_BASE_COMMON}/dispatch/orderPlacementRatio?fromDate=${startDate}&toDate=${endDate}`,
        }).then((response) => {
            if (response.data.resultSet.createdOrders != null)
                setdata(response.data.resultSet)
            else
                setdata(null)
        })
        ReadAxiosc({
            completeURL: `${process.env.REACT_APP_BASE_COMMON}/dispatch/orderPlacementMonthlyReport?fromDate=${startDate}&toDate=${endDate}`,
        }).then((response) => {
            setMonthWise(response.data.resultSet)
        })
    }
    const startDateHandle = (e) => {
        setStart(e)
    }
    let columnDefs = [
        {
            headerName: 'Month', field: 'createdMonth', tooltipField: 'createdMonth', enableRowGroup: false, enablePivot: false, resizable: false, filter: true, minWidth: 50,
            cellRenderer: function (params) {
                return `${params.value} ${params.data.createdYear}`
            }
        },
        { headerName: 'No. of Indents Raised', field: 'totalcreatedOrders', tooltipField: 'totalcreatedOrders', enableRowGroup: true, enablePivot: true, filter: true },
        // { headerName: 'Total Created Orders', field: 'totalcreatedOrders', tooltipField: 'totalcreatedOrders', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'No. of Vehicles Placed', field: 'placedVehicles', tooltipField: 'placedVehicles', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Placement Ratio', field: 'placementRatio', tooltipField: 'placementRatio', enableRowGroup: true, enablePivot: true, filter: true },

    ]
    return (
        <>
            <AgGridTable
                masters={false}
                loading={isLoading}
                columnDefs={columnDefs}
                rowData={monthWise}
                pagination={false}
                titleBarTitle="Order Placement Ratio"
                paginationPageSize={10}
                reportsFilter={
                    <>
                        <div className="container-fluid  text-center p-2 w3-white">
                            <div className="row">
                                <div className="col-md-1 mt-1">
                                    <label>Date</label>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex" style={{ flex: 1 }}>
                                        <div>
                                            <DatePicker
                                                selected={start ? start : defaultStartDate.setDate(1) }
                                                onChange={startDateHandle}
                                                dateFormat="dd/MM/yyyy"
                                                selectsStart
                                                startDate={start}
                                                endDate={end}
                                                showMonthDropdown
                                                placeholderText="Start Date"
                                                className="form-control"
                                            />
                                        </div>
                                                &nbsp;~&nbsp;
                                                <div>
                                            <DatePicker
                                                selected={end ? end : defaultEndDate}
                                                onChange={endDateHandle}
                                                startDate={start}
                                                endDate={end}
                                                showMonthDropdown
                                                minDate={start}
                                                selectsEnd
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <button type="button" onClick={handleSubmit} className="w3-button w3-small w3-blue w3-hover-blue w3-round">Apply</button>
                                </div>
                            </div>

                            {data && <div className="container-fluid m-1 mt-2">
                                <Grid columns='equal'>
                                    <Grid.Row stretched>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No. of Vehicles - To be Placed</Header.Subheader>
                                                        {data.createdOrders}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No. of Vehicles - waiting for Loading</Header.Subheader>
                                                        {data.allotedOrdersToVendor}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No. of Vehicles - Placed</Header.Subheader>
                                                        {data.intransitAndDeliveredTrips}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No. of Vehicles - Not Placed</Header.Subheader>
                                                        {data.notPlacedVehicles}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>Orders Cancelled By Customer</Header.Subheader>
                                                        {data.cancelledOrder}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        {/* <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No of vehicles - Transit</Header.Subheader>
                                                        {data.intransitTrips}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column><Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No of vehicles - Waiting for unloading</Header.Subheader>
                                                        {data.waitingForUnloading}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column> */}
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>No of vechicles - Delivered</Header.Subheader>
                                                        {data.deliveredTrips}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Segment color='blue'>
                                                <Header size="mini" as="h6">
                                                    <Header.Content>
                                                        <Header.Subheader>Grand Total</Header.Subheader>
                                                        <br />
                                                        {data.total}
                                                    </Header.Content>
                                                </Header>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <div className="container-fluid p-2 pt-4 pb-1">
                                    <h5>Data represented here on the basis of month.</h5>
                                </div>
                            </div>}


                        </div>
                    </>}
            />

        </>
    )
}

export default OrderPlacement
